<template>
  <div>
    <div class="content">
      <div class="item border-bottom" v-for="(item , index) in list" :key="index">
        <div>
          <span class="left fs-30">{{item.title}}</span>
          <span class="right fs-30">￥{{item.change_amount}}</span>
        </div>
        <div>
          <span class="left fs-26 c-999">{{item.date}}</span>
          <span class="right fs-24" :class="{in:item.journal_type===3,out:item.journal_type===4}">{{item.journal_type===3?'收入':'支出'}}</span>
        </div>
      </div>
      <!-- <div class="item border-bottom">
        <div>
          <span class="left fs-30">体系课：奔驰变速箱维修技术精品培xxxxxxxxxxxx</span>
          <span class="right fs-30">￥800</span>
        </div>
        <div>
          <span class="left fs-26 c-999">2018-6-16 14:30:41</span>
          <span class="right fs-24 out">收入</span>
        </div>
      </div> -->
      <div class="no-record" v-if="list.length===0&&loaded">暂无打赏记录</div>
    </div>
    <!-- 加载动画 -->
    <loading v-show="!loaded"></loading>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from 'components/base/scroll/scroll'
import Loading from 'components/base/loading/loading.vue'
import {getUserAccountDetail} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      list: [],
      loaded: false
    }
  },
  components: {
    Scroll,
    Loading
  },
  created() {
    // 1是打赏
    getUserAccountDetail(2).then((res) => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        this.list = data.data
        this.loaded = true
      }
    })
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    padding-top size(90)
    padding-bottom size(60)
  .item
    padding size(28) size(30)
    color #333
    >div
      position relative
      padding-right size(160)
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
    >div:last-child
      margin-top size(12)
  .right
    position absolute
    right 0
    top 0
  .fs-32
    font-size size(32)
  .fs-30
    font-size size(30)
  .fs-26
    font-size size(26)
  .fs-24
    font-size size(24)
  .c-999
    color #999
  .out
    color $color-theme
  .in
    color #29c008
  .no-record
    font-size size(30)
    text-align center
    color #999
    padding size(60)
</style>



// WEBPACK FOOTER //
// src/components/personal/wallet/wallet-dashang.vue